import Component from './Login.vue';

export default Component;
